import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ScheduleView } from "@/features/academy/components/schedule-view";

export const scheduleRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/schedule",
  component: ScheduleView,
});
